import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

import { FacadeSacimService } from './facade-sacim.service';
import { ManFileService } from './management-file/man-file.service';
import { TlkService } from './tlk/tlk.service';
import { UserPermissionsService } from './user-permissions/user-permissions.service';

@NgModule({
	declarations: [],
	imports: [CommonModule, TranslateModule],
	providers: [
		TranslateService,
		MessageService,
		FacadeSacimService,
		ManFileService,
		TlkService,
		UserPermissionsService
	],
})
export class SacimModule {}
